import { render, staticRenderFns } from "./MostrarMaterial.vue?vue&type=template&id=95b0c86c&"
import script from "./MostrarMaterial.vue?vue&type=script&lang=js&"
export * from "./MostrarMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports